import * as commonScripts from '../common'
const cmpStatistics = {
  component: null,
  init: function (element) {
    const _ = this
    _.component = element
    commonScripts.util.animationTranslate(this)
  }
}
export default cmpStatistics
